import request, { setHeaderToken } from '../utils/api';
import StoreService from './Store';

export default class HttpService {
  static get(url, params = {}, config = {}) {
    const token = StoreService.getToken();
    setHeaderToken(token);

    return request({
      url,
      method: 'GET',
      params,
      ...config,
    });
  }

  static post(url, data, config = {}) {
    const token = StoreService.getToken();
    setHeaderToken(token);

    return request({
      url,
      method: 'POST',
      data,
      ...config,
    });
  }

  static patch(url, data, config = {}) {
    const token = StoreService.getToken();
    setHeaderToken(token);

    return request({
      url,
      method: 'PATCH',
      data,
      ...config,
    });
  }

  static put(url, data, config = {}) {
    const token = StoreService.getToken();
    setHeaderToken(token);

    return request({
      url,
      method: 'PUT',
      data,
      ...config,
    });
  }

  static delete(url, data, config = {}) {
    const token = StoreService.getToken();
    setHeaderToken(token);

    return request({
      url,
      method: 'DELETE',
      data,
      ...config,
    });
  }
}
